<!-- <div class="wrapper">
    <h5 class="main-title">Best Practice</h5>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card">
                    <div class="modal-header">
                        <h5 class="modal-title">{{InitialQuestionResponce.question}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body symptoms-modal">
                        
                        <ul class="list-unstyled symptoms-list">
                            <li *ngFor="let question of initial_question_options">
                                <ul class="list-unstyled">
                                    <li>
                                        <label class="custom-control-label"> {{question}}</label> 
                                    </li>
                                    <li *ngFor="let optionsQuestion of InitialQuestionResponce.question_options[question];let i=index">
                                        <div *ngIf="optionsQuestion.type == 'radio'">
                                            <div class="custom-control custom-radio custom-control-inline" *ngFor="let optionvalue of optionsQuestion.values;let j=index">
                                                <input [type]="optionsQuestion.type" [id]="question+i+j" [name]="question" (change)="changeradioSelection($event)"
                                                value="{{optionvalue}}" class="custom-control-input">
                                                <label class="custom-control-label" [for]="question+i+j">
                                                    {{optionvalue}}</label>
                                                </div>
                                            </div>
                                            <div *ngIf="optionsQuestion.type == 'checkbox'">
                                                <div class="custom-control custom-checkbox custom-control-inline" *ngFor="let optionvalue of optionsQuestion.values;let j=index">
                                                    <input [type]="optionsQuestion.type" [id]="question+i+j" [name]="question" (change)="changeCheckBoxSelection($event)"
                                                    value="{{optionvalue}}" class="custom-control-input">
                                                    <label class="custom-control-label" [for]="question+i+j">
                                                        {{optionvalue}}</label>
                                                    </div>
                                                </div>
                                                <div *ngIf="optionsQuestion.type == 'number'" >
                                                    <input [type]="optionsQuestion.type" min="0" [id]="question+i" (keyup)="inputNumerValue($event)" [name]="question">
                                                </div>
                                                <div *ngIf="optionsQuestion.type == 'dropdown'">
                                                    <select [id]="question+i" (change)="changeDropDownSelection($event)" [name]="question">
                                                        <option disabled selected>Select Duration</option>
                                                        <option *ngFor="let optionvalue of optionsQuestion.values;let j=index" [value]="optionvalue" [id]="question+i+j">{{optionvalue}}</option>
                                                    </select>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    !-- <li *ngFor="let optionsQuestion of InitialQuestionResponce.question_options[question];let i =index">
                                        <input [id]="optionvalue" type="{{optionsQuestion.type}}" *ngFor="let optionvalue of optionsQuestion.values"
                                        [name]="optionvalue" value="{{optionvalue}}" class="custom-control-input">
                                        <label class="custom-control-label" for="customCheck115">
                                            {{optionsQuestion}}</label>
                                        </li> -
                                    </ul>
                                    
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            
            
            
            <footer class="p-3">
                <div class="container p-0">
                    <div class="d-flex justify-content-between align-items-center">
                        <a class="btn btn-outline-primary" type="button" href="Screen-4.html">Back</a>
                        <p class="mb-0">(4 of 6)</p>
                        <a class="btn btn-primary" type="button" href="Screen-6.html">Next</a>
                    </div>
                </div>
            </footer> -->
            
            
            <div class="wrapper" #scrollMe>
                <div class="container px-0">  
                    <!--<h5 class="main-title">{{patientPersonalInfo.PracticeName}}</h5>-->
                    
                    <form id="regForm" action="">
                        <fieldset class="tab d-block" *ngIf="InitialQuestionResponce?.screen == 'form_screen'"> 
                            <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 mt-1 section-heading">
                              <a (click)="startover()" class="font-weight-bold text-secondary ml-3 cursor-pointer">
                                {{'symptomsQuestion.start_over'|translate}} <i class="fas fa-undo fa-sm text-dark"></i>
                              </a>
                                <h6 class="font-weight-bold mb-0 mr-auto">{{InitialQuestionResponce.question | titlecase}}</h6>
                            </div>
                            
                            <div class="form-group" *ngFor="let question of initial_question_options">
                                <p class="mb-2 mt-4 font-weight-bold " [id]="question">{{question}}</p>  
                                
                                <div class="form-row">
                                    <ng-container *ngFor="let optionsQuestion of InitialQuestionResponce.question_options[question];let i=index"> 
                                        <div class="col-md-6 col-xl-4"  *ngIf="optionsQuestion.type == 'number'">
                                            <div class="form-group border-bottom">
                                                <input type="text" placeholder="{{'symptomsQuestion.duration_placeholder'|translate}}" class="form-control cursor-pointer border-0" [id]="question+i" (input)="inputNumerValue($event)" [name]="question"  maxlength="2"/>
                                            </div>
                                            <!-- <span class="err" [id]="question" style="display: none;">Please Enter Value</span> -->
                                        </div> 
                                        
                                        <div class="col-md-6 col-xl-4 " *ngIf="optionsQuestion.type == 'textbox'">
                                            <div class="form-group border-bottom">
                                                <input type="text" placeholder="{{'symptomsQuestion.text_placeholder'|translate}}." class="form-control cursor-pointer border-0" [id]="question+i" (keyup)="inputtextvalue($event)" [name]="question"  />
                                            </div>
                                            <!-- <span class="err" [id]="question" style="display: none;">Please Enter Value</span> -->
                                        </div>  
                                        <div class="col-md-6 col-xl-4 " *ngIf="optionsQuestion.type == 'dropdown'">
                                            <div class="form-group form-select border-bottom"> 
                                                <select class="form-control cursor-pointer border-0" [id]="question+i" (change)="changeDropDownSelection($event)" [name]="question" >
                                                  <option disabled selected>{{'symptomsQuestion.select_duration'|translate}}</option>
                                                    <option *ngFor="let optionvalue of optionsQuestion.values;let j=index" [value]="optionvalue" [id]="question+i+j">{{optionvalue}}</option>
                                                </select>
                                            </div>
                                            <!-- <span class="err" [id]="question" style="display: none;">Please Select Option</span> -->
                                        </div> 
                                    


                                    <ng-container *ngIf="optionsQuestion.type == 'radio'" class="list-unstyled mb-0 new-symptoms-list"> 
                                        <ng-container  *ngFor="let optionvalue of optionsQuestion.values;let j=index">
                                            <ng-container *ngIf="optionsQuestion.values.length==2">
                                                <div class="col-auto">
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" [type]="optionsQuestion.type" [id]="question+i+j" [name]="question" (change)="changeradioSelection($event)"
                                                        value="{{optionvalue}}">
                                                        <label class="custom-control-label cursor-pointer" [for]="question+i+j" >
                                                            {{optionvalue}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="optionsQuestion.values.length!=2">
                                                <div class="col-sm-6 col-md-4">
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" [type]="optionsQuestion.type" [id]="question+i+j" [name]="question" (change)="changeradioSelection($event)"
                                                        value="{{optionvalue}}">
                                                        <label class="custom-control-label cursor-pointer" [for]="question+i+j" >
                                                            {{optionvalue}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <!-- <span class="err" [id]="question" style="display: none;">Please select any Option</span> -->
                                    </ng-container>
                                    <ng-container *ngIf="optionsQuestion.type == 'checkbox'" class="list-unstyled mb-0 new-symptoms-list">
                                        <div class="col-sm-6 col-md-4" *ngFor="let optionvalue of optionsQuestion.values;let j=index">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" [type]="optionsQuestion.type" [id]="question+i+j" [name]="question" (change)="changeCheckBoxSelection($event)"
                                                value="{{optionvalue}}">
                                                <label class="custom-control-label cursor-pointer" [for]="question+i+j" >
                                                    {{optionvalue}}
                                                </label>
                                            </div>
                                        </div> 
                                        <!-- <span class="err" [id]="question" style="display: none;">Please select any checkbox</span> -->
                                    </ng-container> 
                                    <ng-container *ngIf="optionsQuestion.type == 'calender'">
                                        <div class="col-sm-6 col-md-4" *ngFor="let optionvalue of optionsQuestion.values;let j=index">
                                            <div class="form-group border-bottom"> 
                                                <div class="position-relative">
                                                    <input type="date" class="form-control border-0" [id]="question+i+j" [name]="question"
                                                    placeholder="{{'symptomsQuestion.effective_from_placeholder'|translate}}" (change)="changeCalenderSelection($event)">
                                                    <label [for]="question+i+j" class="cursor-pointer" *ngIf="optionvalue=='fromDate'">{{'symptomsQuestion.from'|translate}}</label>
                                                    <label [for]="question+i+j" class="cursor-pointer" *ngIf="optionvalue=='toDate'">{{'symptomsQuestion.to'|translate}}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container> 
                                </ng-container>
                                </div>
                            </div> 
                        </fieldset> 
                        
                        
                        <fieldset class="tab" *ngIf="InitialQuestionResponce?.screen == 'result_screen'">   
                            <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
                              <a (click)="startover()" class="font-weight-bold text-secondary">
                                {{'symptomsQuestion.start_over'|translate}} <i class="fas fa-undo fa-sm text-dark"></i>
                              </a>
                              <h5 class="font-weight-bold mb-0 mr-auto">{{'symptomsQuestion.history_of_present_illness'|translate}} (HPI)</h5>
                            </div>
                            
                            <p class="text-justify">
                                {{InitialQuestionResponce.result.patient_display_summary}}
                            </p> 
                        </fieldset> 
                    </form>
                    
                </div>
            </div>
            
            <footer class="p-3">
                <div class="container p-0">
                    <div class="d-flex justify-content-between align-items-center">
                      <button class="btn btn-outline-primary" type="button" (click)="backclick()">{{'button.back'|translate}}</button>
                      <!--<p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
                        <button class="btn btn-primary" type="button" (click)="submitTheInitailSymptoms()">{{'button.next'|translate}}</button>
                    </div>
                </div>
            </footer>
            
            <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="questionnotselectedmodel">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body p-4 text-center">
                            <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'symptomsQuestion.validation_text'|translate}}</strong></h5> 
                            <button type="button" data-toggle="modal" data-dismiss="modal" id="questionnotselectedmodel" class="btn btn-primary ">{{'button.ok'|translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="questionnotselecteddate">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body p-4 text-center">
                            <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{dynamicquestionnotselecteddate}}</strong></h5> 
                            <button type="button" data-toggle="modal" data-dismiss="modal" id="questionnotselecteddate" class="btn btn-primary ">{{'button.ok'|translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
            
            
